<template>
  <div
    class="toggle-multiple-options"
    data-toggle="buttons"
  >
    <label
      v-track:click="tenMinuteToggle"
      class="btn btn-toggle-option view-toggle"
      :class="{ active: !toggled }"
      @click="$emit('change', false)"
    >
      Every 10 min
    </label>

    <label
      v-track:click="allScreenshotsToggle"
      class="btn btn-toggle-option view-toggle"
      :class="{ active: toggled }"
      @click="$emit('change', true)"
    >
      All screenshots
    </label>
  </div>
</template>

<script>
export default {
  name: 'ActivitiesAllScreenshotsToggle',
  props: {
    toggled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change'],
  data() {
    const props = { new_value: 'on' };

    return {
      tenMinuteToggle: Object.freeze({ label: 'Every 10 min', props }),
      allScreenshotsToggle: Object.freeze({ label: 'All screenshots', props }),
    };
  },
};
</script>
